import { render, staticRenderFns } from "./SundryCreditorVendorContact.vue?vue&type=template&id=bc0dfb7a"
import script from "./SundryCreditorVendorContact.vue?vue&type=script&lang=js"
export * from "./SundryCreditorVendorContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc0dfb7a')) {
      api.createRecord('bc0dfb7a', component.options)
    } else {
      api.reload('bc0dfb7a', component.options)
    }
    module.hot.accept("./SundryCreditorVendorContact.vue?vue&type=template&id=bc0dfb7a", function () {
      api.rerender('bc0dfb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorVendorContact.vue"
export default component.exports